window.ParsleyConfig = window.ParsleyConfig || {};
window.ParsleyConfig.validators = window.ParsleyConfig.validators || {};
window.ParsleyConfig.i18n = window.ParsleyConfig.i18n || {};
window.ParsleyConfig.i18n.en = window.ParsleyConfig.i18n.en || {};

function parseNumber(v)
{
    if (typeof v != 'string') {
        return parseFloat(v);
    }

    var isDot  = v.indexOf('.');
    var isComa = v.indexOf(',');

    if (isDot != -1 && isComa != -1) {
        if (isComa > isDot) {
            v = v.replace('.', '').replace(',', '.');
        }
        else {
            v = v.replace(',', '');
        }
    }
    else if (isComa != -1) {
        v = v.replace(',', '.');
    }

    return parseFloat(v);
}
//date validation
window.ParsleyConfig.validators.date = {
  fn: function (value) {
    // Process only time case
    if (value.match(/^[012]?\d:\d{2}(\s[ampAMP]{2})?$/)) {
      return true;
    }

    var day, A= value.split(/\D+/).map(function(itm){
        return parseInt(itm, 10);
    });
    try{
        if (bq.config.locale != 'en') {
            A[0] = [A[1], A[1]=A[0]][0]; // swap day/month
        }
        day= new Date(A[2], A[0]-1, A[1]);
        if(day.getMonth()+1== A[0] && day.getDate()== A[1]) return true;
        throw 'Bad Date Format';
    }
    catch(er){
        return false;
    }
  },
  priority: 256
};

// alphanumwithspaces - only alpha, numbers and spaces

window.ParsleyConfig.validators.alphanumwithspaces = {
  fn: function (value) {
    return /^[a-zA-Z0-9 ]+$/.test(value);
  },
  priority: 256
};

window.ParsleyConfig.validators.greaterthanzero = {
    fn: function (value) {
        value = parseNumber(value);
        return !isNaN(value) && value > 0;
    },
    priority: 256
};

/*
Phone Formats :
 (+351) 282 43 50 50
 90191919908
 555-8909
 001 6867684
 001 6867684x1
 1 (234) 567-8901
 1-234-567-8901 x1234
 1-234-567-8901 ext1234
 1-234 567.89/01 ext.1234
 1(234)5678901x1234
 (123)8575973
 (0055)(123)8575973
 */
window.ParsleyConfig.validators.buyerquestphonenumber = {
    fn: function (value) {
        return /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/.test(value);
    },
    priority: 256
};

window.ParsleyConfig.validators.emails = {
  fn: function(val) {
    var email, emails, ret, _i, _len;
    emails = val.split(',');
    ret = true;
    for (_i = 0, _len = emails.length; _i < _len; _i++) {
        email = emails[_i].trim();
        ret = ret && /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(email);
    }
    return ret;
  },
  priority: 256
};

// filetypes validator
window.ParsleyConfig.validators.filetypes = {
  fn: function (value, types) {
    if(!value) return true;
    window.ParsleyConfig.i18n.en.filetypes = bq.messages.global.filetypes + ' ' + types;
    var expr = new RegExp('(' + types.replace(/,/g, '|') + ')$', 'i');
    return expr.test(value);
  },
  priority: 256
};

//split accounting validator
window.ParsleyConfig.validators.accountingallocation = {
    fn: function (value, fieldsSelector) {
        var inputs = jQuery(fieldsSelector);
        return splitAccounting.totalLineAllocation(inputs) == 100;
    },
    priority: 256
};

//upload file size validator
window.ParsleyConfig.validators.filesize = {
    fn: function (value, data) {
        var field = jQuery(data.split(',')[0]);
        var limit = data.split(',')[1];
        var file = field.length && field[0].files ? field[0].files[0] : false;
        if (file && limit) {
            return file.size < limit;
        }
        return true;
    },
    priority: 256
};

// Validate input value less than or equals target value
window.ParsleyConfig.validators.valuelte = {
    fn: function (value, options) {
        var targetId = options.split(',')[0];
        var getter = options.split(',')[1];
        var target = jQuery('#' + targetId);
        var targetValue = target.val();
        if (value != '' && targetValue != '') {
            if (getter) {
                value = eval(getter)(value);
                targetValue = eval(getter)(targetValue);
            }
            return value <= targetValue;
        } else {
            return true;
        }
    },
    priority: 256
};

// Validate input value greater than or equals target value
window.ParsleyConfig.validators.valuegte = {
    fn: function (value, options) {
        var targetId = options.split(',')[0];
        var getter = options.split(',')[1];
        var target = jQuery('#' + targetId);
        var targetValue = target.val();
        if (value != '' && targetValue != '') {
            if (getter) {
                value = eval(getter)(value);
                targetValue = eval(getter)(targetValue);
            }
            return value >= targetValue;
        } else {
            return true;
        }
    },
    priority: 256
};

// Validate input value greater than or equals target value
window.ParsleyConfig.validators.price = {
    fn: function (value, options) {
        var numberValue = parseInt(value.replace(/,/g, ''), 10);
        var ret = true;
        ret = ret && /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/i.test(value)
            && (value.length <= parseInt(options[2], 10))
            && numberValue >= parseInt(options[0], 10)
            && numberValue <= parseInt(options[1], 10);
        return ret;
    },
    priority: 256
};

//new split accounting validator (remove old one)
window.ParsleyConfig.validators.inttotal = {
  fn: function (value, options) {
    var el = jQuery(options[1]);
    var exact = options[0];
    var total = 0;
    var totalValid = true;

    el.filter(':visible').each(function(){
      total = 0;
      var e = jQuery(this),
          valid = true,
          elements = e.find('[data-validate-inttotal]');

      elements.each(function() {
        var q = parseFloat(jQuery(this).val());
        if (q <= 0) {
          valid = false;
        }
        total += q;
      });

      total = +(total).toFixed(12);
      valid = !elements.length || (valid && (parseInt(total) === parseInt(exact)));

      if(!valid) {
        totalValid = false;
      } else {
        var form = e.closest('form');

        setTimeout(function(){
          e.find('[data-validate-inttotal]').closest('.has-error, .has-success').each(function(){
            var field = jQuery(this);
            field.removeClass('has-error has-feedback has-success');
            field.find('.form-control-feedback').remove();
          });
        }, 50);

        /* This code fix was implemented for BQEP-6888, but it breaks BQEP-7200.
         * If first issue ever occurs again, fix it with keeping the second one in mind.
        if(!form.data('revalidate')) {
          form.data('revalidate', true);
          setTimeout(function(){
            if(form.data('revalidate')) {
              form.parsley().validate();
              form.data('revalidate', false);
            }
          }, 100);
        }
        */
      }
    });
    return totalValid;
  },
  priority: 256
};

window.ParsleyConfig.validators.onefieldrequired = {
    fn: function (value, className) {
        var el = jQuery(className);
        var valid = false;
        el.filter(':visible').each(function(){
            if (jQuery(this).val() != '') {
                valid = true;
            }
        });
        return valid;
    },
    priority: 256
};

window.ParsleyConfig.validators.notequalto = {
    fn: function (value, params) {
        value = jQuery.trim(value);
        var el = jQuery("[name='" + params[1] + "']");
        var valid = false;
        if (el.val() != value) {
            valid = true;
        }
        return valid;
    },
    priority: 256
};

window.ParsleyConfig.validators.loginid = {
    fn: function (value) {
        value = jQuery.trim(value);
        return value && /^[0-9a-zA-Z\/\\\!#%&\-\*\+\?_=\^\$"\@\.:;,'\(\)\{\}\]\[\|<>~`]+$/i.test(value);
    },
    priority: 256
};

window.ParsleyConfig.validators.qtyinput = {
    fn: function (value) {
        var currencies = bq.react && bq.react.settings && bq.react.settings.price_formats
            ? bq.react.settings.price_formats
            : {};
        var currency = bq.react && bq.react.settings && bq.react.settings.user && bq.react.settings.user.currency
            ? bq.react.settings.user.currency
            : '';
        var numberFormat = currencies[currency] || {};
        var thousandSeparator = numberFormat.groupSymbol || ',';
        value = jQuery.trim(value).replaceAll(thousandSeparator, '');
        var pattern, regex;
        var maxPrecision = bq.global.maxLengths.quantityPrecision;
        var maxLength = bq.global.maxLengths.quantityInput;
        var pointIndex = value.indexOf('.');
        if (pointIndex !== -1) {
            var precision = value.substr(pointIndex).length - 1;
            if (value.length > maxLength || precision > maxPrecision) {
                return false;
            }
            var maxIntegerPartLength = Math.min(maxLength - precision - 1, 11);
            pattern = '^[1-9][0-9]{0,' + maxIntegerPartLength + '}[.][0-9]{0,' + precision + '}$|^[0]?[.][0-9]{0,' + precision + '}$';
        } else {
            if (value.length > 1) {
                value = value.replace(/^0+/, '');
            }
            if (!value.length) {
                value = '0';
            }
            pattern = '^([1-9][0-9]{0,11}|[0])$';
        }

        regex = new RegExp(pattern);
        return value && regex.test(value);
    },
    priority: 1
};

window.ParsleyConfig.validators.netamount = {
    fn: function (value, param) {
        value = jQuery.trim(value);
        return !isNaN(value) && value > 0 && value <= param;
    },
    priority: 256
};

window.ParsleyConfig.validators.minnetamount = {
    fn: function (value, param) {
        value = jQuery.trim(value);
        return !isNaN(value) && value > 0 && value >= param;
    },
    priority: 256
};

window.ParsleyConfig.validators.floatnumber = {
    fn: function (value, param) {
        value = jQuery.trim(value);
        param = param ? param : 2;
        param = parseInt(param);
        var pattern, regex;
        if (isNaN(param)) {
            return false;
        }

        if (param === 0) {
            pattern = '^[+-]?\d+$';
        } else {
            pattern = '^[+-]?([0-9]+([.][0-9]{0,' + param + '})?|[.][0-9]{0,' + param + '})$';
        }

        regex = new RegExp(pattern);
        return regex.test(value);
    },
    priority: 256
};

window.ParsleyConfig.validators.expirationdate = {
    fn: function (value, param) {
        value = jQuery.trim(value);
        if (!/^\d{2}\/(\d{2}|\d{4})$/.test(value)) {
            return false;
        }

        var expDate = value.split('/');
        if (expDate.length !== 2) {
            return false;
        }

        var today = new Date();
        var exMonth = expDate[0];
        var exYear = expDate[1];

        if (exYear.length === 2) {
            exYear = today.getFullYear().toString().slice(0, 2) + exYear.toString();
        }

        if (parseInt(exYear) > today.getFullYear() + 15) {
            return false;
        }

        var intExMonth = parseInt(exMonth);
        if (intExMonth < 1 || intExMonth > 12) {
            return false;
        }

        var cardExpirationDate = new Date();
        var result = cardExpirationDate.setFullYear(exYear, exMonth, 1);
        if (isNaN(result)) {
            return false;
        }

        return cardExpirationDate > today;
    },
    priority: 256
};

window.ParsleyConfig.validators.dependentverifiers = {
    fn: function () {
        var verifierValidationResult = true;
        var inputValidationResult;
        var inputs = jQuery('input.item-verifier');
        if (inputs.length) {
            for (var i = 0; i < inputs.length; i++) {
                if (verifierValidationResult) {
                    inputValidationResult = jQuery(inputs[i]).parsley().validate();
                    verifierValidationResult = (Array.isArray(inputValidationResult) && inputValidationResult.length)
                        ? false
                        : !!inputValidationResult;
                }
            }
        }
        return verifierValidationResult;
    },
    priority: 512
};

!(function($, window) {
  //validation messages
  window.ParsleyConfig.i18n.en = $.extend(window.ParsleyConfig.i18n.en || {}, {
    date: bq.messages.global.dateInvalid,
    alphanumwithspaces: bq.messages.global.alphaNumInvalid,
    emails: bq.messages.global.emailInvalid,
    filetypes: bq.messages.global.filetypes,
    accountingallocation: bq.messages.global.accountingallocation,
    filesize: bq.messages.global.fileSize,
    valuelte: bq.messages.global.valuesmismatch,
    valuegte: bq.messages.global.valuesmismatch,
    inttotal: bq.messages.global.accountingallocation,
    price: bq.messages.global.priceValidation
  });
})(jQuery, window);
